// Thin wrapper over the gtag stub in public/index.html. When
// VUE_APP_GA_MEASUREMENT_ID is unset at build time no gtag is emitted, so every
// call here is a no-op. Deliberately events only — page_view stays owned by
// GA4 Enhanced Measurement so we don't double-count SPA navigations.
export const track = (event, params = {}) =>
  window.gtag?.('event', event, params)
